<template>
    <div class="w-100 d-flex flex-column ">
        <h3 class="col d-flex " v-if="terrCode && terrLabel">
            <span class="mr-1"> Territoire d'étude :</span>
            <span v-if="terrLevelSelected == 'multi_code'" class="text-primary ml-2">
                Multi départemental ({{ userPerims.dep_complet.toString() }})
            </span>
            <span v-else class="text-primary"> {{ terrLabelTitleSelected }} ({{ terrCode }})
                {{ terrLabel }}</span>
        </h3>
        <h3><i class="fa fa-download  text-primary" aria-hidden="true"></i> Exportation des données</h3>
        <div class="card">
            <Loading v-if="isSpinning" class="text-center" />
            <div v-else class="card-body">
                <div class="bg-primary p1 text-center text-white" style="width:100px;">Millésimes</div>
                <div class="form-group" v-if="millesimes && millesimes.length > 0">
                    <select class="form-control" id="millesimerefs" v-model="selectedmillesime">
                        <option :value="null">Sélectionner un millésime</option>
                        <option v-for="ref in millesimes" :key="ref.id" :value="ref.id">
                            {{ ref.title }}
                        </option>
                    </select>
                </div>
                <div v-else class="text-center my-4">
                    <p>Désolé, aucun millésime de données n'est disponbile pour cette séléction.</p>
                </div>
                
                <div class="bg-primary mt-4 p1 d-flex flex-row justify-content-between text-white w-100"
                    style="width:100px;">
                    <div class="p-1">Filtrer mes données</div>
                    <div class="btn btn-sm btn-primary" @click="clearFilter">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <path fill="#FFF"
                                d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254L1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z" />
                        </svg>
                        Réinitialiser
                    </div>
                </div>
                <div
                    class="d-flex flex-row justify-content-start align-items-start border border-primary rounded p-2">

                    <div class="d-flex flex-column  w-100 align-items-start ">
                        <div class="text-primary pb-2 font-weight-bold font-size-md">TERRITORIAL </div>
                        <div class="d-flex flex-column flex-md-row align-items-center w-100">
                            <div v-if="displaySearch" class="form-group col-12 ">
                                <SearchTerr :level="'com'" :parentterr="terrCodeSelected"
                                    @selected="handleSelectedTerr">
                                    Filtrer une commune
                                </SearchTerr>
                            </div>
                            <div class="form-group col-12"
                                v-if="zonage && zonage.length > 0 && !displaySearch">
                                <label for="exampleFormControlSelect1" class="font-weight-bold">Zonage</label>
                                <select class="form-control" id="millesimerefs" v-model="zonageSelected"
                                    @change="handleSublevelChange">
                                    <option :value="null">Tous mes territoires</option>
                                    <option v-for="(terr, index) in zonage" :key="index" :value="terr">
                                        ({{ terr.code }}) {{ terr.nom }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-1 "
                                v-if="terrLevelSelected === 'dep' || displaySearch">
                                <div class="d-flex justify-content-between align-item-center">

                                    <div class="mx-2 text-center text-xs" style="font-size:0.6rem;margin-top:25px;">
                                        ou
                                        <br>
                                        filtrer
                                    </div>
                                    <div @click="displaySearch = !displaySearch">
                                        <div class="pp-btn-search">
                                            <svg v-if="!displaySearch" xmlns="http://www.w3.org/2000/svg" width="25"
                                                height="25" viewBox="0 0 16 16">
                                                <path fill="currentColor"
                                                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0" />
                                            </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                viewBox="0 0 16 16">
                                                <path fill="currentColor"
                                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8L4.646 5.354a.5.5 0 0 1 0-.708" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column  w-100 align-items-start ">
                        <div class="text-primary pb-2 font-weight-bold font-size-md">THÉMATIQUE</div>
                        <div class="d-flex flex-column flex-md-row align-items-center w-100">
                            <div class="form-group col-12" v-if="zonage && zonage.length > 0">
                                <label class="font-weight-bold" for="fragil_stat">Type</label>
                                <select class="form-control" id="fragil_stat" v-model="filterType"
                                    @change="handleSublevelChange">
                                    <option value="null">PPOM</option>
                                    <option value="ppom">PPOM renforcé</option>
                                    <option value="pav_degrade">Suspicion pavillonnaire dégradé</option>
                                </select>
                            </div>
                        </div>
                    </div> 
                </div>
                <div class=" w-100 d-flex flex-row justify-content-end align-items-center my-3 text-right">
                        <div class="text-primary">Télécharger mes données (format csv)</div>
                        <button v-if="selectedmillesime" class="btn btn-primary  ml-2" @click="handleEportData('csv')">CSV</button>
                        <div v-else class="btn disabled">Merci de sélctionner un millésime</div>
                        <!--<button class="btn btn-primary ml-2" @click="handleEportData('xlsx')">XLSX</button>-->
                    </div>
            </div>
        </div>
        <b-modal id="loadmodal" ref="loadmodal" ok-diseabled="true" ok-title="ok" :no-close-on-backdrop="true"
            cancel-title="Annuler" title="Exportation de données en cours" header-bg-variant="primary"
            header-text-variant="fbmWhite">
            <div class="text-center">
                <i class="fa fa-cloud-download fa-3x text-primary" aria-hidden="true" v-if="!isSpinning"></i>
                <br>
                <p class="my-4" v-html="exportMsg"></p>
                <a v-if="exportPath && displayDownloadBtn && !isSpinning" :href="exportPath" class="btn btn-primary">
                    Télécharger mes données
                </a>
                <fbm-rotate-spinner v-if="isSpinning"></fbm-rotate-spinner>
            </div>
            <template slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" @click="hideModal"> Fermer </b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { PGService } from '../../services/PGService';
import CogApiService from '../../services/CogApiService';
import { ExportDataService } from '../../services/ExportDataService';
import Loading from '../Loading.vue';
import SearchTerr from './SearchTerr.vue';

const cogApiService = new CogApiService();

export default {
    name: "ppom_export",
    props: ['section', 'dfperims', 'siret', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected'],
    components: {
        Loading, SearchTerr
    },
    data: function () {
        return {
            csrf: null,
            base_zonnage: null,
            isSpinning: false,
            tablesRef: null,
            exportMsg: '',
            displayDownloadBtn: true,
            exportDispo: false,
            exportPath: '',
            exportCountRow: null,
            selectedmillesime: null,
            millesimes: null,
            zonage: [],
            zonageSelected: null,
            fragilType: null,
            fragNote: [],
            immat_only: false,
            filterType: null,
            useNull: false,
            no_immat_only: false,
            myReg: "11",
            userPerims: null,
            multiCodes: null,
            terrLevel: null,
            terrLabelTitleSelected: null,
            terrCode: null,
            terrLabel: null,
            displaySearch: false,
            subLevel: null,
            ept_coms: null,
            that: this
        }
    },
    mounted() {
        this.isSpinning = true;
        this.userPerims = JSON.parse(this.dfperims);
        //console.log("dfperims : ", this.userPerims, this.terrLevelSelected, this.terrCodeSelected, this.terrLabelSelected);
        this.terrLabel = this.terrLabelSelected;
        this.terrCode = this.terrCodeSelected;
        this.base_zonnage = this.buildDFPerims(this.userPerims.df_ano);

        axios.get("/api/ppom-refs").then((response) => {
            //console.log("millesimes : ", response.data, typeof (response.data));
            this.millesimes = response.data;
            this.selectedmillesime = response.data.filter((m) => m.status === "current")[0].id;
            this.isSpinning = false;

        }).catch((e) => {
            console.log("Erreur de récupeation des millésimes de données : ", e);
            this.isSpinning = false;
        });

        this.buildUserLevel();
    },
    watch: {
        zonageSelected: (val) => {
            //console.log("zonage selected", val.code);
        },
        coproSize: (val) => {
            console.log("coproSize", val);
        },
        selectedmillesime: (val) => {
            console.log("selectedmillesime", val);
        },
        useNull: (val) => {
            console.log("useNull", val);
        },
        immat_only: (val) => {
            console.log("immat_only", val);
        },
        displaySearch: {
            handler: function (val) {
                console.log("displaySearch", val);
                if (val == false) {
                    this.buildDFPerims(this.userPerims);
                    this.buildUserLevel();
                }
            }
        }
    },
    methods: {

        hideModal: function () {
            this.$refs.loadmodal.hide();
        },
        buildDFPerims: function (refPerims) {
            let perims = { "level": null, "code": null };
            if (this.terrLevelSelected === "ept" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "ept";
                //this.terrCodeSelected = refPerims.comm[30];
                this.terrLabelTitleSelected = "EPT ";
                this.ept_coms = refPerims.comm;
                //console.log("ept_coms", this.ept_coms);
                return { "level": 'ept', "code": this.ept_coms[30], "label": "EPCI" };
            }

            if (this.terrLevelSelected === "epci" && refPerims.comm && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                this.terrLevelSelected = "epci";
                //this.terrCodeSelected = this.;
                this.terrLabelTitleSelected = "EPCI ";
                this.ept_coms = refPerims.comm;
                return { "level": 'epci', "code": this.terrCodeSelected, "label": "EPCI" };
            }

            if ("fr_entiere" in refPerims && refPerims.fr_entiere) {
                this.terrLevelSelected = "fra";
                this.terrCodeSelected = "fra";
                this.terrLabelTitleSelected = "";
                return { "level": 'fra', "code": 'fra', "label": "France entière" };
            }
            if ("reg" in refPerims && Array.isArray(refPerims.reg) && refPerims.reg.length > 0) {
                this.terrLevelSelected = "reg";
                this.terrCodeSelected = refPerims.reg[0];
                this.terrLabelTitleSelected = "Région ";
                return { "level": 'reg', "code": refPerims.reg[0], "label": "Régions" };
            } else if ("dep" in refPerims && Array.isArray(refPerims.dep) && refPerims.dep.length > 0) {

                if (refPerims.dep.length > 1) {
                    this.terrLevelSelected = "multi_dep";
                    this.terrLabelTitleSelected = "Multi départemental "
                    this.multiCodes = refPerims.dep;
                    this.terrCodeSelected = refPerims.dep[1];
                } else {
                    this.terrLevelSelected = "dep";
                    this.terrLabelTitleSelected = "Département ";
                    this.terrCodeSelected = refPerims.dep[0];
                }

                return { "level": 'dep', "code": refPerims.dep[0], "label": "Département" };

            } else if ("comm" in refPerims && Array.isArray(refPerims.comm) && refPerims.comm.length > 0) {
                let coms = refPerims.comm;
                this.terrLevelSelected = "com";
                this.terrCodeSelected = coms[0];
                this.terrLabelTitleSelected = "Commune ";
                return { "level": 'com', "code": coms.length > 0 ? coms[0] : [], "label": "Communes" };
            } else {
                return null;
            }
        },
        buildUserLevel: function () {
            //console.log("terrLevelSelected", this.terrLevelSelected);
            switch (this.terrLevelSelected) {
                case 'fra':
                    axios.get("https://geo.api.gouv.fr/regions?fields=nom,code")
                        .then((result) => {
                            this.terrLabelSelected = "France entière";
                            let filteredReg = result.data.filter((reg) => reg.code !== "01" && reg.code !== '03' && reg.code !== '06');
                            this.zonage = filteredReg
                        })
                    break;
                case 'reg':
                    this.terrCodeSelected = (this.terrCodeSelected && this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/regions/${this.terrCodeSelected}/departements?fields=nom,code,region`)
                        .then((result) => {
                            this.terrLabelSelected = result.data[0].region.nom;
                            this.zonage = result.data;
                        })
                    break;
                case ('multi_dep'):
                    this.terrCodeSelected = (this.terrCodeSelected && this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    this.zonage = [];
                    this.userPerims.df_ano.dep.forEach((elem) => {
                        elem = elem.length === 1 ? '0' + elem : elem;
                        axios.get(`https://geo.api.gouv.fr/departements/${elem}?fields=nom,cod,codeRegion,region`)
                            .then((result) => {
                                this.terrLabelSelected = result.data.nom;
                                this.zonage = [
                                    ...this.zonage,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                ]
                                this.zonage = this.zonage.sort((a, b) => a.code > b.code ? 1 : -1);
                            })
                    })

                    break;
                case ('dep'):
                    this.terrCodeSelected = (this.terrCodeSelected && this.terrCodeSelected.length === 1) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    this.zonage = [];
                    this.userPerims.df_ano.dep.forEach((elem) => {
                        elem = elem.length === 1 ? '0' + elem : elem;
                        axios.get(`https://geo.api.gouv.fr/departements/${elem}?fields=nom,cod,codeRegion,region`)
                            .then((result) => {
                                this.terrLabelSelected = result.data.nom;
                                this.zonage = [
                                    ...this.zonage,
                                    {
                                        "code": result.data.code,
                                        "nom": result.data.nom
                                    }
                                ]
                            })
                    })
                    break;
                case 'epci':
                    axios.get(`https://geo.api.gouv.fr/epcis/${this.terrCodeSelected}/communes?fields=nom,code,codesDepartements`)
                        .then((result) => {
                            //console.log('coms for epci', result.data);
                            this.zonage = result.data;
                            if (result.data.find(el => String(el.code) == '13055')) {
                                //console.log("epci 13055 trouvé!");
                                this.zonage = this.zonage.filter(el => el.code != '13055');
                                let arrond = cogApiService.getArrondissments('13055');
                                this.zonage = [...this.zonage, ...arrond];
                                this.zonage.sort((a, b) => a.nom < b.nom ? 1 : -1);
                            }
                            if (result.data.find(el => String(el.code) == '69123')) {
                                this.zonage = this.zonage.filter(el => el.code != '69123');
                                let arrond = cogApiService.getArrondissments('69123');
                                this.zonage = [...this.zonage, ...arrond];
                                this.zonage.sort((a, b) => a.nom < b.nom ? 1 : -1);
                            }
                            if (result.data.find(el => String(el.code) == '75056')) {
                                //console.log("epci 75056 paris!");
                                this.zonage = this.zonage.filter(el => el.code != '75056');
                                let arrond = cogApiService.getArrondissments('75056');
                                //console.log("arrondissements de paris", arrond);
                                this.zonage = [...this.zonage, ...arrond];
                                this.zonage.sort((a, b) => a.nom < b.nom ? 1 : -1);
                            }
                            this.subLevel = "com";
                            this.terrLabelSelected = result.data.nom;
                        })
                    break;
                case 'ept':
                    this.zonage = [];
                    
                    this.ept_coms.forEach((com, index) => {
                        axios.get(`https://geo.api.gouv.fr/communes/${com}?fields=code,nom`)
                            .then((result) => {
                                this.zonage = [...this.zonage,
                                {
                                    "code": result.data.code,
                                    "nom": result.data.nom
                                }
                                ];

                                if (index === this.ept_coms.length - 1) {
                                    this.subLevel = "com";
                                    //this.terrLabelSelected = result.data.nom;
                                }
                            })
                    })
                    break;
                case 'com':
                    this.terrCodeSelected = (this.terrCodeSelected.length === 4) ? '0' + this.terrCodeSelected : this.terrCodeSelected;
                    axios.get(`https://geo.api.gouv.fr/communes/${this.terrCodeSelected}?fields=departement`)
                        .then((result) => {
                            this.terrLabelSelected = result.data.nom;
                            this.subLevel = "com";
                            this.zonage = [{
                                "code": result.data.code,
                                "nom": result.data.nom
                            }]
                        })
                    break;
                default:
                    this.zonage = null;
                    break;
            }
        },
        handleSelectedTerr: function (terr, level) {
            this.zonageSelected = terr;
            this.terrLevelSelected = level;
        },
        handleFragilNoteChange: function (e) {
            //console.log("handleFragilNoteChange", e);
            this.fragNote.includes(e) ? this.fragNote = this.fragNote.filter((elem) => elem !== e) : this.fragNote.push(e);
            //console.log(this.fragNote);
        },
        handleSublevelChange: function (e) {
            let that = this;
            switch (this.terrLevelSelected) {
                case 'fra':
                    this.subLevel = "reg";
                    break;
                case 'reg':
                    this.subLevel = "dep";
                    break;
                case 'multi_dep':
                    this.subLevel = 'dep';
                case 'dep':
                    this.subLevel = "dep";
                    break;
                case 'epci':
                    that.subLevel = "com";
                    break;
                case 'ept':
                    that.subLevel = "com";
                    break;
                case 'com':
                    this.subLevel = null;
                    break;
                default:
                    this.subLevel = null;
                    break;
            }
        },
        handleEportData: function (fileFrmt = 'csv') {
            this.isSpinning = true;
            this.$refs.loadmodal.show();
            this.exportMsg = "Exportation de données en cours, veuillez patienter...";

            this.terrLevelSelected === 'multi_dep' && !this.terrCodeSelected ? this.terrCodeSelected = this.userPerims.dep_complet : null;

            axios.post("/ppom_extract", {
                file_format: fileFrmt,
                millesime: this.selectedmillesime,
                terr_code: this.subLevel && this.zonageSelected  ? this.zonageSelected.code : this.terrCodeSelected,
                terr_label: this.subLevel && this.zonageSelected ? this.zonageSelected.nom : null,
                terr_level: this.subLevel && this.zonageSelected ? this.subLevel : this.terrLevelSelected,
                filter_type: this.filterType,

            }).then((response) => {
                this.exportCountRow = response.data.data.count;
                if (this.exportCountRow > 0) {
                    this.exportMsg = "Exportation terminée, cliquez sur le lien pour télécharger vos données archivées ";
                    this.displayDownloadBtn = true;
                    this.exportPath = response.data.data.zip;
                } else {
                    this.displayDownloadBtn = false;
                    this.exportMsg = "Votre recherche ne renvoie aucun résultat, veuillez réessayer avec d'autres critères de recherche ";
                }
                this.isSpinning = false;
                this.buildDFPerims(this.userPerims);
                this.buildUserLevel()
                this.resetZonage();
                this.displaySearch = false;

            }).catch((e) => {
                console.log("Erreur de récupeation des données : ", e);
                this.displayDownloadBtn = false;
                this.exportMsg = "Erreur lors de l'exportation, veuillez réessayer ultérieurement";
                this.isSpinning = false;
                this.buildDFPerims(this.userPerims);
                this.buildUserLevel()
                this.resetZonage();
                this.displaySearch = false;
            });
        },
        resetZonage: function () {
            if (this.zonage && this.zonage.length > 0) {
                this.zonageSelected = null;

            }
        },
        clearFilter: function () {
            this.terrLevelSelected = null;
            this.terrCodeSelected = null;
            this.terrLabelSelected = null;
            this.zonageSelected = null;
            this.fragilType = null;
            this.fragNote = null;
            this.immat_only = false;
            this.coproSize = null;
            this.useNull = false;
            this.no_immat_only = false;
            this.filterType = null;
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    opacity: 0.5 !important;
}

.pp-coprof-export-check-correction {
    padding-bottom: 5px;
    text-align: left;
    margin-top: -12px;
}

.pp-coprof-export-check-input {
    border: 1px solid #cccccc;
    text-align: center;
    border-radius: 0px;
    padding: 7px 5px;
    margin-top: 8px;
}

.pp-btn-search {
    background-color: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(127 126 126);
    border-radius: 999px;
    border: 1px solid rgb(192 192 192);
    padding: 6px;
    cursor: pointer;
    width: 26px;
    height: 26px;
    margin-top: 30px;
    ;

    &:hover {
        background-color: #cacaca;
        color: white;
    }
}
</style>